export class User{
    constructor(firstName: String, eMail: String, age: number, password:String, number: String, plan:String) {
    }
}